import { useRef, useLayoutEffect } from 'react';
import { ErrorContainer } from 'library/styles/text';
import {
  StyledInput,
  Container,
  Icon,
} from './styles';

const MIN_HEIGHT = 56;

const Input = ({
  error,
  inputRef,
  isDirty,
  iconClassName,
  isLoading = false,
  formatterMap,
  ...props
}) => {
  const element = useRef();
  const lines = props.value.split('\n');
  const isSingleLine = lines.length <= 1;

  const setElementHeight = () => {
    if(element.current) {
      const { scrollHeight } = element.current;

      const height = isSingleLine ? MIN_HEIGHT : scrollHeight;

      element.current.style.height = 'inherit';
      element.current.style.height = `${height}px`;
    }
  };

  useLayoutEffect(() => {
    setElementHeight();
  }, [props.value]);

  return (
    <Container isLoading={isLoading}>
      <Icon className={isLoading ? 'icon-loader' : iconClassName} />
      <StyledInput
        {...props}
        ref={element}
        style={{
          ...(isSingleLine ? { lineHeight: '56px' } : { lineHeight: '20px', paddingTop: '16px', paddingBottom: '16px' }),
        }}
        value={(formatterMap && formatterMap[props.value]) ? formatterMap[props.value] : props.value}
        hasError={isDirty && Boolean(error?.message)}
        isLoading={isLoading}
        onBlur={isLoading ? undefined : props.onBlur}
        onWheelCapture={(e) => {
          e.target.blur();
        }}
        readOnly={isLoading ? true : props.readOnly}
        isFocusDisabled={Boolean(props.onClick)}
      />
      {error ? <ErrorContainer>{error.message}</ErrorContainer> : null}
    </Container>
  );
};

export default Input;
